export default __webpack_public_path__ + "static/media/icon-arrow-down.612d4ec0.svg";